var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("mb" + _vm.gap)},[_c('core-files-card',{attrs:{"filesOf":"case","id":_vm.computedCaseId,"canWrite":_vm.canWrite,"list":_vm.files},on:{"file:deleted":_vm.fetchFiles,"files:uploaded":_vm.fetchFiles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }